var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStripeLogoRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10C0 4.47715 4.47715 0 10 0H58C63.5228 0 68 4.47715 68 10V58C68 63.5228 63.5228 68 58 68H10C4.47715 68 0 63.5228 0 58V10Z",
    fill: "#635BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.3481 26.4351C31.3481 24.8371 32.6571 24.2081 34.8331 24.2081C37.9611 24.2081 41.9051 25.1601 45.0331 26.8431V17.1871C41.7921 15.9076 38.3343 15.2668 34.8501 15.3001C26.5031 15.3001 20.9611 19.6521 20.9611 26.9281C20.9611 38.2671 36.5841 36.4651 36.5841 41.3611C36.5841 43.2481 34.9351 43.8601 32.6401 43.8601C29.2231 43.8601 24.8711 42.4661 21.4201 40.5791V50.3541C24.9618 51.8902 28.7795 52.6885 32.6401 52.7001C41.1911 52.7001 47.0731 48.4671 47.0731 41.1061C47.0051 28.8661 31.3481 31.0421 31.3481 26.4351Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripeLogoRounded);
export default __webpack_public_path__ + "static/media/stripe-logo-rounded.7974c07cf3409028b9d8f32dcde98567.svg";
export { ForwardRef as ReactComponent };